const ErrorBoundary = () => "There has been an error. Please try again.";

export default ErrorBoundary;
